// Copyright ©️ 2026 eVolve MEP, LLC

import type { Shipment } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { useShipments } from 'modules/Shop/Shipments/ShipmentsPage/useShipments';

type Props = ModalRegistryManagedProps & {
  shipment: Shipment;
  onShipmentDeleted: () => void;
};

export const DeleteShipmentModal = ({ shipment, onShipmentDeleted, ...props }: Props) => {
  const { deleteShipment } = useShipments();
  return (
    <WrappedModal
      title="Delete shipping order"
      confirmationText="Delete"
      onConfirm={async () => {
        await deleteShipment(shipment.shipmentId);
        notifications.show({
          title: 'Successfully deleted shipping order',
          message: `Shipping order ${shipment.name} deleted.`,
          color: 'green',
        });
        onShipmentDeleted();
      }}
      {...props}
    >
      <Text>
        Are you sure you want to delete shipping order <b>{shipment.name}</b>? All associated work order items will be
        removed from this shipping order. This action cannot be undone.
      </Text>
    </WrappedModal>
  );
};
